import { ComponentRef, ViewContainerRef } from '@angular/core';
import { ChangePasswordComponent } from './change-password.component';

export class ChangePasswordFormSession {
  clientContext: any;
  viewContainerRef: ViewContainerRef;
  ChangePasswordComponent: ComponentRef<ChangePasswordComponent>;


  actionContext: any;
  submitHandler: any;
  mode: any;
  title: string;
  username: string;

  constructor(title, username){
      this.title = title;
      this.username = username;
  }
  // this.submitHandler = null;

  startSession(
    description: com.ts.mobile.sdk.AuthenticatorDescription,
    mode: com.ts.mobile.sdk.AuthenticatorSessionMode,
    actionContext: com.ts.mobile.sdk.PolicyAction | null,
    clientContext: object | null
  ): void {
    this.actionContext = actionContext;
    this.clientContext = clientContext;
    this.mode = mode;

  }

  endSession(): void {
    this.clientContext['cookieService'].delete('errorPwdCode');
  }

  promiseInput(): Promise<com.ts.mobile.sdk.InputOrControlResponse<ResponseType>>{
    this.viewContainerRef = (this.clientContext as any).viewContainerRef;
    this.viewContainerRef.clear();

    this.ChangePasswordComponent = this.viewContainerRef.createComponent(ChangePasswordComponent);
    this.ChangePasswordComponent.instance.onPasswordSubmit = this.onCurrentPasswordSubmit;

    this.ChangePasswordComponent.instance.onChangePasswordSkipClick = this.onChangePasswordSkipSubmit.bind(this);

    return new Promise((resolve, reject) => {
      this.submitHandler = (response) => {
        resolve(response);
      };
    });
  }

  promiseRecoveryForError(
    error: com.ts.mobile.sdk.AuthenticationError,
    validRecoveries: Array<com.ts.mobile.sdk.AuthenticationErrorRecovery>,
    defaultRecovery: com.ts.mobile.sdk.AuthenticationErrorRecovery
  ): Promise<com.ts.mobile.sdk.AuthenticationErrorRecovery> {
    return new Promise((resolve, reject) => {
      const userEmail = this.clientContext['cookieService'].get('username');
      const newLocal = 'additional_data';
      const errorCode = error.getData()[newLocal].code;

      if (errorCode !== '' && errorCode !== null && errorCode !== undefined){ // incorrect password
        setTimeout(() => this.ChangePasswordComponent.instance.setErrorCode(errorCode), 100);
        resolve(com.ts.mobile.sdk.AuthenticationErrorRecovery.RetryAuthenticator);
      }
    });
  }

  onError(payload: object): void {}

  changeSessionModeToRegistrationAfterExpiration() {
  }

  onCurrentPasswordSubmit = (code: string) => {
    const inputResponse = com.ts.mobile.sdk.PasswordInput.create(code);
    const response = com.ts.mobile.sdk.InputOrControlResponse.createInputResponse(inputResponse);

    this.clientContext['cookieService'].set('errorPwdCode', code, undefined, undefined, null, true, 'None');
    this.submitHandler(response);
  }

  onChangePasswordSkipSubmit = () => {
    const userEmail = this.clientContext['cookieService'].get('username');
    const url = this.clientContext['redirect_uri'];
    const state = this.clientContext['state'];
    const errorCode  = 'cancel_password';
    let appendChar = '?';
    if (url.includes('?'))
    {
       appendChar = '&';
    }
    window.location.href = url + appendChar + 'error=' + errorCode + '&error_description=cancel_password' 
    + '&lang=' + this.clientContext['cookieService'].get('lang')
    + '&state=' + state;
  }

}
interface ActionsInPayload {
  [key: string]: any;
}

interface JourneyPayload {
  actions: ActionsInPayload[];
  stat: string;
  code: string;
  flow: string;
}
export default ChangePasswordFormSession;
